"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ReliableFlowForYourHome() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223681" id="empowering-people-and-processes" className="relative bg-background text-foreground overflow-hidden py-24 lg:py-32">
            {}
            <div className="absolute inset-0 z-0 opacity-10 pointer-events-none bg-[linear-gradient(to_right,var(--color-border)_1px,transparent_1px),linear-gradient(to_bottom,var(--color-border)_1px,transparent_1px)] bg-[size:4rem_4rem]" aria-hidden="true" />

            <div className="container mx-auto px-4 relative z-10">
                <div className="grid lg:grid-cols-12 gap-12 lg:gap-8 items-center">
                    
                    {}
                    <div ref={ref} className={`lg:col-span-6 flex flex-col gap-8 transition-all duration-1000 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`}>
                        <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold font-default tracking-tighter text-foreground leading-[1.1]"><span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-secondary">Empowering</span> People, <br /> Strengthening Communities</h1>
                        
                        <p className="text-lg sm:text-xl text-muted-foreground font-default leading-relaxed max-w-2xl">Since 2017, Long Ships has delivered practical skills development, social facilitation and community development solutions that empower people and strengthen communities. Our growing BPO capability extends this impact by helping organisations improve efficiency, build capacity and scale with confidence.</p>
                        
                        <div className="flex flex-wrap items-center gap-4 pt-4">
                            <Button size="lg" className="h-14 px-8 text-base rounded-md shadow-xl bg-primary text-primary-foreground hover:scale-105 transition-transform" asChild>
                                <Link to="/GetInTouchPage">Get in Touch</Link>
                            </Button>
                            <Button variant="ghost" size="lg" className="h-14 px-8 text-base rounded-md border border-border hover:bg-accent hover:text-accent-foreground" asChild>
                                <Link to="/BpoServicesPage">BPO Services</Link>
                            </Button>
                        </div>
                    </div>

                    {}
                    <div className="lg:col-span-6 relative flex justify-center lg:justify-end mt-12 lg:mt-0">
                        {}
                        <style>{`
                            @keyframes float-organic-mask {
                                0%, 100% { 
                                    transform: translateY(0) scale(1); 
                                    border-radius: 60% 40% 30% 70% / 60% 30% 70% 40%; 
                                }
                                50% { 
                                    transform: translateY(-20px) scale(1.02); 
                                    border-radius: 40% 60% 70% 30% / 50% 60% 30% 60%; 
                                }
                            }
                            .animate-water-drop {
                                animation: float-organic-mask 8s ease-in-out infinite;
                            }
                        `}</style>

                        <div className="relative w-full max-w-lg aspect-square">
                            {}
                            <div className="absolute inset-0 bg-gradient-to-tr from-primary/20 to-secondary/20 blur-3xl animate-water-drop" style={{
              animationDelay: '-4s'
            }} aria-hidden="true" />

                            {}
                            <div className="relative w-full h-full animate-water-drop overflow-hidden shadow-3xl border border-white/10 bg-muted backdrop-blur-xl">
                                <img src="https://longshipskills.co.za/wp-content/uploads/2026/10/long-ships-training-gqeberha-web.jpg" alt="Abstract 3D network visualization representing BPO efficiency" className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700" />
                                {}
                                <div className="absolute inset-0 bg-gradient-to-t from-background/80 via-transparent to-transparent pointer-events-none" aria-hidden="true" />
                                
                                {}
                                <div className="absolute top-8 left-8 bg-primary/90 text-primary-foreground px-4 py-2 rounded-md font-mono text-sm shadow-lg backdrop-blur-md">
                                    EST. 2017
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>;
}